import { apiClient } from "../../../lib/api-client";

export type AuthProviderName = "google" | "vk";

export interface AuthProviderDefinition {
  name: AuthProviderName;
  clientId: string;
}

export interface AuthProviderClientIds {
  google?: string;
  vk?: string;
}

const buildClientIds: AuthProviderClientIds = {
  google: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  vk: import.meta.env.VITE_VK_CLIENT_ID,
};

const providerOrder: readonly AuthProviderName[] = ["google", "vk"];

export function resolveAuthProviders(
  backendProviders: readonly unknown[],
  clientIds: AuthProviderClientIds = buildClientIds
): AuthProviderDefinition[] {
  const enabledByBackend = new Set(
    backendProviders.filter(
      (provider): provider is AuthProviderName =>
        provider === "google" || provider === "vk"
    )
  );

  return providerOrder.flatMap((name) => {
    const clientId = clientIds[name]?.trim();
    return enabledByBackend.has(name) && clientId
      ? [{ name, clientId }]
      : [];
  });
}

export async function fetchAuthProviders(
  clientIds: AuthProviderClientIds = buildClientIds
): Promise<AuthProviderDefinition[]> {
  const response = await apiClient.get<unknown>("/auth/providers");

  if (
    typeof response !== "object" ||
    response === null ||
    !("providers" in response) ||
    !Array.isArray(response.providers)
  ) {
    throw new Error("Invalid auth providers response");
  }

  return resolveAuthProviders(response.providers, clientIds);
}
